// Check if the HTML string has any anchors.
export const hasAnchors = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  const anchors = div.querySelectorAll("a");
  return anchors.length > 0;
};
